import React from "react";
import { TicketForm } from "src/pages/TicketForm";

const NoAuthWorkRequests = () => {
  return <TicketForm isNoAuthWorkRequest={true} />;
};

export default NoAuthWorkRequests;
